export default __webpack_public_path__ + "static/media/loginPage.7f2737ba.png";